import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressBarComponent } from '../../../@commons/@components/progress-bar/progress-bar.component';
import { GddBadgeComponent } from '../../../@commons/@components/gdd-badge/gdd-badge.component';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { Router } from '@angular/router';
import RoutesConstants from '../../../@commons/constants/routes.constants';
import { LocationLabelPipe } from '../../../@commons/pipes/location-label.pipe';

export interface GddMilestoneItem {
  plantUid: string;
  cultivationUid?: string;
  variantUid?: string;
  cultivationName: string;
  variantName: string;
  locationName?: string;
  currentStepName: string;
  progress: number;
  estimatedDaysLeft: number | null;
  conditionBadge: 'FAVORABLE' | 'NORMAL' | 'UNFAVORABLE';
}

@Component({
  selector: 'vw-gdd-milestones-widget',
  standalone: true,
  imports: [CommonModule, TranslateModule, ProgressBarComponent, GddBadgeComponent, SharedModule, LocationLabelPipe],
  templateUrl: './gdd-milestones-widget.component.html',
  styleUrls: ['./gdd-milestones-widget.component.scss'],
})
export class GddMilestonesWidgetComponent {
  @Input() items: GddMilestoneItem[] = [];
  @Input() maxItems: number = 5;

  constructor(private router: Router) {}

  get visibleItems(): GddMilestoneItem[] {
    return [...this.items]
      .sort((a, b) => {
        if (a.conditionBadge === 'UNFAVORABLE' && b.conditionBadge !== 'UNFAVORABLE') return -1;
        if (b.conditionBadge === 'UNFAVORABLE' && a.conditionBadge !== 'UNFAVORABLE') return 1;
        return b.progress - a.progress;
      })
      .slice(0, this.maxItems);
  }

  progressPercent(progress: number): number {
    // Defensive clamp: old API payloads can still carry an unbounded ratio
    return Math.min(100, Math.max(0, Math.round(progress * 100)));
  }

  estimatedDate(daysLeft: number | null): Date | null {
    if (daysLeft == null) return null;
    const date = new Date();
    date.setDate(date.getDate() + Math.round(daysLeft));
    return date;
  }

  onPlantClick(item: GddMilestoneItem) {
    // Navigate to the canonical plant-detail route when we have the full path,
    // otherwise fall back to the garden list.
    if (item.cultivationUid && item.variantUid) {
      this.router.navigate([
        '/garden/cultivations',
        item.cultivationUid,
        'variants',
        item.variantUid,
        'plants',
        item.plantUid,
      ]);
    } else {
      this.router.navigate([RoutesConstants.GARDEN_LIST]);
    }
  }
}
